export const BookingsActions = {
    LOAD_INQUIRY: 'LOAD_INQUIRY',
    LOAD_BOOKINGS: 'LOAD_BOOKINGS',
    LOAD_DETAIL: 'LOAD_DETAIL',
    CONFIRM: 'CONFIRM',
    DECLINE: 'DECLINE',
    OFFER: 'OFFER',
};

export const BookingsMutation = {
    REQUEST: 'REQUEST',
    SUCCESS_INQUIRY: 'SUCCESS_INQUIRY',
    SUCCESS_BOOKINGS: 'SUCCESS_BOOKINGS',
    SUCCESS_DETAIL: 'SUCCESS_DETAIL',
    ERROR: 'ERROR',
    REQUEST_BOOKING: 'REQUEST_BOOKING',
    SUCCESS_BOOKING: 'SUCCESS_BOOKING',
    ERROR_BOOKING: 'ERROR_BOOKING',
};
